/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Image_AltInputs */

const en_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfer teeing off on a coastal golf course overlooking the ocean`)
};

const es_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfista saliendo desde el tee en un campo de golf costero con vista al océano`)
};

const de_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfer beim Abschlag auf einem Küstengolfplatz mit Blick auf den Ozean`)
};

const zh_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高尔夫球手在俯瞰大海的海滨球场开球`)
};

const ar_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاعب غولف يضرب ضربة البداية في ملعب غولف ساحلي يطل على المحيط`)
};

const fr_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfeur frappant son départ sur un parcours de golf côtier surplombant l'océan`)
};

const vi_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người chơi golf phát bóng trên sân golf ven biển nhìn ra đại dương`)
};

const sw_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji wa gofu akipiga pigo la kwanza kwenye uwanja wa gofu wa pwani unaotazama bahari`)
};

const th_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักกอล์ฟกำลังตีออกจากแท่นทีบนสนามกอล์ฟริมชายฝั่งที่มองเห็นมหาสมุทร`)
};

const bs_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfer izvodi početni udarac na obalnom golf terenu s pogledom na okean`)
};

const ja_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海を見下ろす海辺のゴルフコースでティーショットを打つゴルファー`)
};

const ko_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바다가 내려다보이는 해안 골프장에서 티샷을 하는 골퍼`)
};

const pt_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfista dando a tacada de saída em um campo de golfe costeiro com vista para o oceano`)
};

const it_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfista che tira dal tee su un campo da golf costiero affacciato sull'oceano`)
};

const sv_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfare slår ut från tee på en kustbana med utsikt över havet`)
};

const nl_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfer slaat af op een kustgolfbaan met uitzicht op de oceaan`)
};

const da_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfspiller slår ud på en kystbane med udsigt over havet`)
};

const nb_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfspiller slår ut på en kystbane med utsikt over havet`)
};

const fi_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfaaja lyö avauslyöntiä rannikkokentällä merinäköalalla`)
};

const pl_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfista wykonuje uderzenie z tee na nadmorskim polu golfowym z widokiem na ocean`)
};

const ru_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гольфист выполняет первый удар на прибрежном поле для гольфа с видом на океан`)
};

const tr_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okyanusa bakan sahil kenarındaki bir golf sahasında tee atışı yapan golfçü`)
};

const hi_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समुद्र की ओर देखते तटीय गोल्फ़ कोर्स पर टी-ऑफ़ करता गोल्फ़र`)
};

const id_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegolf melakukan tee off di lapangan golf pesisir yang menghadap ke samudra`)
};

const ms_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain golf melakukan pukulan permulaan di padang golf pesisir pantai yang menghadap lautan`)
};

const cs_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfista odpaluje na přímořském golfovém hřišti s výhledem na oceán`)
};

const el_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γκόλφερ κάνει το εναρκτήριο χτύπημα σε παραθαλάσσιο γήπεδο γκολφ με θέα στον ωκεανό`)
};

const he_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גולפאי מבצע חבטת פתיחה במגרש גולף חופי המשקיף אל האוקיינוס`)
};

const af_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gholfspeler wat afslaan op 'n kusgholfbaan met uitsig oor die see`)
};

const hu_home_hero_image_alt = /** @type {(inputs: Home_Hero_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfozó elüt a teeről egy óceánra néző tengerparti golfpályán`)
};

/**
* | output |
* | --- |
* | "Golfer teeing off on a coastal golf course overlooking the ocean" |
*
* @param {Home_Hero_Image_AltInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_hero_image_alt = /** @type {((inputs?: Home_Hero_Image_AltInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Image_AltInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_image_alt(inputs)
	if (locale === "de") return de_home_hero_image_alt(inputs)
	if (locale === "zh") return zh_home_hero_image_alt(inputs)
	if (locale === "ar") return ar_home_hero_image_alt(inputs)
	if (locale === "fr") return fr_home_hero_image_alt(inputs)
	if (locale === "vi") return vi_home_hero_image_alt(inputs)
	if (locale === "sw") return sw_home_hero_image_alt(inputs)
	if (locale === "th") return th_home_hero_image_alt(inputs)
	if (locale === "bs") return bs_home_hero_image_alt(inputs)
	if (locale === "ja") return ja_home_hero_image_alt(inputs)
	if (locale === "ko") return ko_home_hero_image_alt(inputs)
	if (locale === "pt") return pt_home_hero_image_alt(inputs)
	if (locale === "it") return it_home_hero_image_alt(inputs)
	if (locale === "sv") return sv_home_hero_image_alt(inputs)
	if (locale === "nl") return nl_home_hero_image_alt(inputs)
	if (locale === "da") return da_home_hero_image_alt(inputs)
	if (locale === "nb") return nb_home_hero_image_alt(inputs)
	if (locale === "fi") return fi_home_hero_image_alt(inputs)
	if (locale === "pl") return pl_home_hero_image_alt(inputs)
	if (locale === "ru") return ru_home_hero_image_alt(inputs)
	if (locale === "tr") return tr_home_hero_image_alt(inputs)
	if (locale === "hi") return hi_home_hero_image_alt(inputs)
	if (locale === "id") return id_home_hero_image_alt(inputs)
	if (locale === "ms") return ms_home_hero_image_alt(inputs)
	if (locale === "cs") return cs_home_hero_image_alt(inputs)
	if (locale === "el") return el_home_hero_image_alt(inputs)
	if (locale === "he") return he_home_hero_image_alt(inputs)
	if (locale === "af") return af_home_hero_image_alt(inputs)
	if (locale === "hu") return hu_home_hero_image_alt(inputs)
	return en_home_hero_image_alt(inputs)
});